// Mobile number + the text-message consent box, laid out as on the approved opt-in
// screen (docs/sms-mfa/optin-mockup.html): "US +1" prefix, the number, and an
// unticked box with the carrier-registered wording. Used by /signup and by
// Account settings -> Sign-in methods.
import React from 'react';
import { CONSENT_PARTS } from './smsConsent';
import './PhoneConsentFields.css';

export default function PhoneConsentFields({
  idPrefix, phone, onPhoneChange, agreed, onAgreedChange, disabled = false,
}) {
  const phoneId = `${idPrefix}-phone`;
  const consentId = `${idPrefix}-consent`;
  return (
    <div className="phone-consent">
      <label htmlFor={phoneId} className="phone-consent__label">Mobile number</label>
      <div className="phone-consent__phone">
        <span className="phone-consent__cc">US +1</span>
        <input
          id={phoneId}
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          className="phone-consent__input"
          placeholder="(555) 010-0142"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          disabled={disabled}
        />
      </div>
      <div className="phone-consent__consent">
        <input
          id={consentId}
          type="checkbox"
          className="phone-consent__box"
          checked={agreed}
          onChange={(e) => onAgreedChange(e.target.checked)}
          disabled={disabled}
        />
        <label htmlFor={consentId} className="phone-consent__text">
          {CONSENT_PARTS.map((part, i) => (typeof part === 'string'
            ? <React.Fragment key={i}>{part}</React.Fragment>
            : <a key={i} href={part.href} target="_blank" rel="noopener noreferrer">{part.text}</a>))}
        </label>
      </div>
    </div>
  );
}
